import React, { useState, useEffect } from "react";
import { PageHeader, Form, Tabs } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { API } from "../../config/config";
import InformationForm from "./Form/Information";
import GroupsForm from "./Form/Groups";
import ContactForm from "./Form/Contact";
import ChangePasswordForm from "./Form/ChangePassword";
import TwoFA from "./Form/TwoFA";
import GroupAccess from "./../../helper/GroupAccess";
import ApiTokenForm from "./Form/ApiToken";

const { TabPane } = Tabs;

const DATA_URL = "/profile/";
const DATA_URL_UPDATEPROFILE = "/updateprofile/";
const DATA_URL_UPDATEGROUPS = "/updategroups/";
const DATA_URL_CHANGEPASSWORD = "/changepassword/";
const DATA_URL_CHANGEAPITOKEN = '/changeapitoken/';

const Profile = (props) => {
    const [data, setData] = useState();
    const [groups, setGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [apiTokenBtnDisabled, setApiTokenBtnDisabled] = useState(true);

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        layout: "horizontal",
        size: "middle",
    };
    const tailLayout = {
        wrapperCol: { offset: 4, span: 14 },
    };

    const { t } = props;

    useEffect(() => {
        if (loading) {
            getProfile();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const formValChange = (chgV, allV) => {
        setData({ ...data, ...allV });
    };

    const onCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setData({ ...data, [`${name}`]: +checked });
    };

    const onGroupsCheckboxChange = (event) => {
        const { name } = event.target;
        const keys = name.split("|");
        const gid = groups[keys[0]][keys[1]];
        setSelectedGroups(
            selectedGroups.find((selected) => selected === gid) ? selectedGroups.filter((selected) => selected !== gid) : [...selectedGroups, gid]
        );
    };

    const fillValue = (Obj) => {
        form.setFieldsValue(Obj);
    };

    const getProfile = () => {
        const apiUrl = DATA_URL;

        try {
            axios
                .get(API + apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
                .then(({ data }) => {
                    setData(data.profile);
                    setGroups(data.optiongroups);
                    setSelectedGroups(data.selectedgroups);
                    fillValue(data.profile);
                    setLoading(false);
                })
                .catch((error) => error);
        } catch (error) {
            throw error;
        }
    };

    const onFinish = () => {
        const request = {
            ...data,
        };
        delete request.username;
        delete request.status;
        delete request.password;
        delete request.password1;
        delete request.password2;
        delete request.password3;
        delete request.password4;
        delete request.password_changed;
        delete request.locked;
        delete request.last_attempt;
        delete request.last_update;
        delete request.dashboard;

        const apiUrl = DATA_URL_UPDATEPROFILE;
        axios
            .post(API + apiUrl, request, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then((result) => {
                if(localStorage.loggedUser){
                    let parseLoggedUser = JSON.parse(localStorage.loggedUser);
                    parseLoggedUser.email = request.email;
                    parseLoggedUser.firstname = request.firstname;
                    parseLoggedUser.lastname = request.lastname;
                    parseLoggedUser.fullname = request.firstname + request.lastname;
                    localStorage.loggedUser = JSON.stringify(parseLoggedUser);
                }
                Swal.fire({
                    icon: "success",
                    title: t("login.dialogs.profile_changed"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: t("login.dialogs.catch"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            });
    };

    const onFinishGroups = () => {
        const request = {
            uid: data.uid,
            groups: selectedGroups,
        };

        const apiUrl = DATA_URL_UPDATEGROUPS;
        axios
            .post(API + apiUrl, request, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then((result) => {
                Swal.fire({
                    icon: "success",
                    title: t("login.dialogs.groups_changed"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: t("login.dialogs.catch"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            });
    };

    const onFinishChangePassword = () => {
        const apiUrl = DATA_URL_CHANGEPASSWORD;
        axios
            .post(
                API + apiUrl,
                { uid: data.uid, password: data.new_password, current_password: data.old_password },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token") } }
            )
            .then((result) => {
                Swal.fire({
                    icon: "success",
                    title: t("login.dialogs.password_changed"),
                    showConfirmButton: false,
                    timer: 2000,
                    onClose: () => {
                        props.history.push("/logout");
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                const apiMsg = error?.response?.data?.error_msg;
                const hasApiMsg = typeof apiMsg === "string" && !!apiMsg;
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: hasApiMsg ? apiMsg : t("login.dialogs.catch"),
                    showConfirmButton: hasApiMsg,
                    timer: hasApiMsg ? undefined : 2000,
                });
            });
    };

    const onFinishChangeAPIToken = () => {
        const request = {
            api_token: data.api_token,
            uid: data.uid
        };

        const apiUrl = DATA_URL_CHANGEAPITOKEN;
        axios
            .post(API + apiUrl, request, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then((result) => {
                Swal.fire({
                    icon: "success",
                    title: t("login.dialogs.api_token_change"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: t("login.dialogs.catch"),
                    showConfirmButton: false,
                    timer: 2000,
                });
            }).finally(() => {
                setApiTokenBtnDisabled(true);
            });
    }

    return (
        <div>
            <PageHeader className="site-page-header" title={t("contents.profile.title")}></PageHeader>
            <div className="site-layout-background" style={{ padding: "0 24px", minHeight: 360 }}>
                {!loading ? (
                    <Tabs defaultActiveKey="1">
                        <TabPane tab={t("contents.profile.tabs.general_information")} key="1">
                            <InformationForm
                                t={t}
                                data={data}
                                layout={layout}
                                tailLayout={tailLayout}
                                form={form}
                                onValuesChange={formValChange}
                                onSubmit={onFinish}
                                onCheckboxChange={onCheckboxChange}
                            />
                        </TabPane>
                        <TabPane tab={t("contents.profile.tabs.contact")} key="2">
                            <ContactForm
                                t={t}
                                data={data}
                                layout={layout}
                                tailLayout={tailLayout}
                                form={form}
                                onValuesChange={formValChange}
                                onSubmit={onFinish}
                            />
                        </TabPane>
                        {GroupAccess("SYSADMIN") ? (
                            <TabPane tab={t("contents.profile.tabs.group")} key="3">
                                <GroupsForm
                                    t={t}
                                    data={data}
                                    layout={layout}
                                    tailLayout={tailLayout}
                                    groups={groups}
                                    selectedGroups={selectedGroups}
                                    onCheckboxChange={onGroupsCheckboxChange}
                                    onSubmit={onFinishGroups}
                                />
                            </TabPane>
                        ) : null}
                        <TabPane tab={t("contents.profile.tabs.change_password")} key="4">
                            <ChangePasswordForm
                                t={t}
                                data={data}
                                layout={layout}
                                tailLayout={tailLayout}
                                onValuesChange={formValChange}
                                onSubmit={onFinishChangePassword}
                            />
                        </TabPane>
                        {GroupAccess("APIACCESS") ? (
                            <TabPane tab={t("contents.profile.tabs.api_token")} key="5">
                            <ApiTokenForm 
                                t={t}
                                data={data}
                                form={form}
                                layout={layout}
                                tailLayout={tailLayout}
                                onValuesChange={formValChange}
                                onSubmit={onFinishChangeAPIToken}
                                apiTokenBtnDisabled={apiTokenBtnDisabled}
                                setApiTokenBtnDisabled={setApiTokenBtnDisabled}
                                 />
                        </TabPane>
                        ): null}
                        <TabPane tab={t("contents.profile.tabs.2fa")} key="6">
                            <TwoFA t={t} data={data} form={form} layout={layout} />
                        </TabPane>
                    </Tabs>
                ) : null}
            </div>
        </div>
    );
};

export default Profile;
